import posthog from 'posthog-js';

export const Tracking = {
	identify(userId: string, properties: Record<string, any> = {}) {
		if (!userId) return;
		posthog.identify(userId, properties);
	},

	group(groupType: string, groupKey: string, groupProperties: Record<string, any> = {}) {
		posthog.group(groupType, groupKey, groupProperties);
	},

	capture(event: string, properties: Record<string, any> = {}) {
		posthog.capture(event, properties);
	},

	alias(newId: string) {
		posthog.alias(newId);
	},

	reset() {
		posthog.reset();
	},

	userInfo(): { distinctId: string } {
		return { distinctId: posthog.get_distinct_id() };
	},
};
